export default __webpack_public_path__ + "static/media/DEVSOCLogo.79c85518.png";